"use client";
import dayjs from "dayjs";

export const formatTime12h = (time24) => {
  if (!time24) return "";
  const [hStr, mStr] = time24.split(":");
  let h = parseInt(hStr, 10);
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${mStr} ${ampm}`;
};

export const showDateTime = (selectDate, selectTime, label = "Select Date & Time") => {
  if (selectDate) {
    const d = dayjs(selectDate);
    const isCurrentYear = d.year() === dayjs().year();
    const datePart = isCurrentYear ? d.format("D MMM") : d.format("D MMM YY");
    const timePart = selectTime ? formatTime12h(selectTime) : "";
    return timePart ? `${datePart}, ${timePart}` : datePart;
  }
  return label;
};

export const convertTime12to24 = (time12h) => {
  const [time, modifier] = time12h.split(" ");

  let [hours, minutes] = time.split(":");

  if (hours === "12") {
    hours = "00";
  }

  if (modifier === "PM") {
    hours = parseInt(hours, 10) + 12;
  }
  return `${hours}:${minutes}:00`;
};

export const calculateDaysHour = (startDatetime, endDateTime) => {
  const startDate = dayjs(startDatetime.replace(/-/g, "/"));
  const endDate = dayjs(endDateTime.replace(/-/g, "/"));
  const daysDifference = endDate.diff(startDate, "day");
  const remainingHours = endDate.diff(startDate, "hour") % 24;
  if (daysDifference > 0 && remainingHours > 0) {
    return `${daysDifference} Days ${remainingHours} Hrs`;
  } else if (daysDifference > 0) {
    return `${daysDifference} Days`;
  } else {
    return `${remainingHours} Hrs`;
  }
};

export const getFinalVehicleList = (vehicles, startDatetime, endDateTime) => {
  const finalVehicleList = [];
  for (const avialType in vehicles) {
    for (const arrVehicle in vehicles[avialType]) {
      let countTotalTime = {
        totalDayTime: calculateDaysHour(startDatetime, endDateTime),
      };

      if (vehicles[avialType][arrVehicle].length > 1) {
        let location = [];
        let locatnObj = {};

        vehicles[avialType][arrVehicle].map((item) => {
          locatnObj = {
            ...item.location,
            ...item.rent,
            ...{ fuelType: item?.vehicle?.fuelType },
            ...{ transmissionType: item?.vehicle?.transmissionType },
            ...{ partialStatus: item?.vehicle?.partialStatus },
            ...{ key: item.key },
            ...{ bookingCount: item?.bookingCount ?? 0 },
          };

          location.push(locatnObj);
        });

        const otherlocation = { otherlocation: location };
        vehicles[avialType][arrVehicle].map((item, index) => {
          if (index === 0) {
            const statusVehicle = { vehicleStatus: avialType };
            finalVehicleList.push({
              ...item,
              ...statusVehicle,
              ...otherlocation,
              ...countTotalTime,
            });
          }
        });
      } else {
        const statusVehicle = { vehicleStatus: avialType };
        vehicles[avialType][arrVehicle].map((item) => {
          finalVehicleList.push({
            ...item,
            ...statusVehicle,
            ...countTotalTime,
          });
        });
      }
    }
  }
  return finalVehicleList;
};

export const getSingleVehicleList = (
  vehiclesData,
  startDatetime,
  endDateTime
) => {
  const { vehicles, details } = vehiclesData;
  const finalVehicleList = [];
  let objDetails = [];
  for (const cartItemList in details) {
    objDetails.push(details[cartItemList]);
  }
  for (const avialType in vehicles) {
    let countTotalTime = {
      totalDayTime: calculateDaysHour(startDatetime, endDateTime),
      startDatetime: startDatetime,
      endDateTime: endDateTime,
    };
    const arroptn = [];
    for (const arrVehicle in vehicles[avialType]) {
      arroptn.push(vehicles[avialType][arrVehicle]);
    }
    if (Object.keys(vehicles[avialType]).length > 1) {
      let locatnObj = {};
      let location = [];
      arroptn.map((item) => {
        locatnObj = {
          ...item.location,
          ...item.rent,
          ...{ fuelType: item?.vehicle?.fuelType },
          ...{ transmissionType: item?.vehicle?.transmissionType },
          ...{ partialStatus: item?.vehicle?.partialStatus },
          ...{ key: item.key },
          ...{ cartItemList: details.cartItemList },
        };
        location.push(locatnObj);
      });
      const otherlocation = { otherlocation: location };
      arroptn.map((item, index) => {
        if (index === 0) {
          const statusVehicle = { vehicleStatus: avialType };
          finalVehicleList.push({
            ...item,
            ...statusVehicle,
            ...otherlocation,
            ...countTotalTime,
          });
        }
      });
    } else {
      const statusVehicle = { vehicleStatus: avialType };
      arroptn.map((item) => {
        finalVehicleList.push({
          ...item,
          ...statusVehicle,
          ...countTotalTime,
          ...{ cartItemList: details.cartItemList },
        });
      });
    }
  }
  return finalVehicleList;
};

export function truncateContent(content, maxLength) {
  if (content.length > maxLength) {
    return content.substring(0, maxLength) + "...";
  }
  return content;
}

